<template>
  <!-- isScreenShow  true 横屏 -->
  <div class="live-model" :class="{ 'swiper-vertical': isScreenShow }">
    <!-- <div class="zs">{{p}}   </div> -->
    <div
      :class="{ 'screen-model': isScreen }"
      :style="'z-index: ' + (liveInfo.info.status == 2 ? '25;' : '')"
    >
      <div v-if="isPageLoading">
        <!-- start 直播开始 -->
        <div v-if="liveInfo.info.status != 2 && liveInfo.user.black_status != 0">
          <van-loading type="spinner" class="loading" v-if="!isShowInit && isLiveLoading" />
          <div class="play" v-if="isShowInit">
            <img
              @click="openLiveFg()"
              class="icon"
              src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/qst_img/live_bofang.png"
            />
          </div>
        </div>

        <!-- 拉黑 -->
        <div v-if="liveInfo.user.black_status == 0" class="black_wrap">
          <div class="mask" bindtap="showBottomPop"></div>
          <img :src="liveInfo.info.cover_image" />
          <div class="black_status">您已被主播踢出房间，即将退出</div>
        </div>

        <!-- 主播离开 -->
        <div v-if="liveInfo.info.status != 2 && liveInfo.user.black_status == 1">
          <div class="leave" v-if="liveInfo.info.status == 4">
            <div>主播暂时离开，马上回来</div>
          </div>
        </div>

        <!-- 直播已结束 -->
        <div class="live_end" v-if="liveInfo.info.status == 2">
          <img :src="liveInfo.info.cover_image" />
          <div class="end_wrap">
            <div class="live_info">
              <img :src="liveInfo.live_user.avatar" />
              <div>
                <span>{{ liveInfo.live_user.username }}</span>
              </div>
            </div>
            <div class="title">
              <div class="end">直播已结束</div>
              <div class="time gray">直播时长 {{ liveInfo.info.length_time }}</div>
            </div>
            <div class="statistics">
              <div>
                <div class="fs40">{{ liveInfo.info.watch_num }}</div>
                <div class="fs28 gray">观看</div>
              </div>
              <div>
                <div class="fs40">{{ liveInfo.info.like_num }}</div>
                <div class="fs28 gray">点赞</div>
              </div>
            </div>
            <div class="btn_wrap">
              <div @click="triggerMethod">返回</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 直播区域 -->
      <div
        id="container"
        class="container"
        :class="{
          'container-vertical': isScreenShow && !isScreen,
          alyPlayeVideo: isScreenShow && !isScreen && currentPlayer == 2,
          alyPlayeVideoHeng: isScreenShow && isScreen && currentPlayer == 2,
        }"
      ></div>
    </div>

    <!-- 底部弹出 -->
    <van-popup
      v-model="isBottomPopup"
      :position="isScreenShow && isScreen ? 'left' : 'bottom'"
      :style="{
        height: isScreenShow && isScreen ? '100%' : '30%',
        width: isScreenShow && isScreen ? '6rem' : '',
      }"
    >
      <div
        class="bottom-flex"
        :class="{
          'popup-rotate':
            isScreenShow && isScreen && !liveInfo.user.follow_status,
          'popup-rotate-reports':
            isScreenShow && isScreen && liveInfo.user.follow_status,
        }"
      >
        <div @click="goReportsFg" class="reports-vertical">
          <img :src="basicUrl + 'iconjubao.png'" alt />
          <div>举报</div>
        </div>
        <div
          v-for="(i, idx) in playerName"
          :key="idx"
          @click="checkPlayer(idx)"
          class="reports-vertical"
        >
          <img
            :src="
              basicUrl +
              [currentPlayer == idx ? '1126_live2.png' : '1126_live1.png']
            "
            alt
          />
          <div>{{ i }}</div>
        </div>
        <div @click="focusFg" v-if="liveInfo.user.follow_status">
          <img :src="basicUrl + 'iconquxiaoguanzhu.png'" alt />
          <div>取消关注</div>
        </div>
      </div>
    </van-popup>

    <!-- 点赞区域 -->
    <div
      class="give-like-icon"
      :class="{ 'like-rotate': isScreen }"
      :style="'left:' + likePostion.x + 'px;top:' + likePostion.y + 'px;'"
    ></div>

    <!-- 轮播  -->
    <van-swipe
      v-if="liveInfo.user.black_status != 0"
      class="my-swipe"
      :vertical="isScreen"
      :show-indicators="false"
      :loop="false"
      indicator-color="white"
    >
      <van-swipe-item>
        <div class="live-model-swiper" :class="{ 'screen-model': isScreen }">
          <!-- 切换横竖屏 -->
          <!-- 暂时 -->
          <img
            v-if="isScreenShow"
            @click="changeScreenFg(currentPlayer == 1 ? 1 : 0)"
            class="change-vertical"
            :src="basicUrl + 'icon_dang.png'"
            alt
            :style="isScreen ? 'top:4rem;' : ''"
          />
          <!-- 全屏点赞 -->
          <div @click="giveLike" class="give-like"></div>

          <!-- 观看区域 -->
          <div class="live-model-top flex-b">
            <div class="live-room flex">
              <img
                :src="
                  liveInfo.live_user.avatar ||
                  'https://qst-static-resource.oss-cn-shenzhen.aliyuncs.com/h5_card_info/163056289787865.png'
                "
                alt
              />
              <div>
                <div class="room-name">{{ liveInfo.live_user.username }}</div>
                <!-- <div class="room-watch">{{realNumber}}人观看</div> -->
                <div class="room-watch">{{ liveInfo.info.watch_num }}人观看</div>
              </div>
              <div class="live-focus" @click="focusFg" v-if="!liveInfo.user.follow_status">关注</div>
            </div>

            <div class="watch-img">
              <!-- <img
                v-for="(item, index) in invitaFew"
                :key="index"
                :src="item.avatar"
              />-->
              <img @click="openWatchFg" :src="imgPath + 'live_more.png'" />
            </div>
          </div>

          <!-- 右侧广告位  start -->
          <div class="rightBtn" v-if="rightButton.length > 0">
            <div v-for="(item, index) in rightButton" :key="index" @click="advertFg(item)">
              <img :src="item.advert_image" class="rightButtonImage" />
            </div>
          </div>
          <div class="column_x flex_b" v-if="isScreenShow">
            <p>{{ this.liveInfo.info.title }}</p>
            <span @click.stop="openShareModel" class="live-focus">分享</span>
          </div>

          <!-- 左滑按钮 -->
          <div class="scroll-left" :class="{ 'scroll-left-screen': isScreen }">
            <img
              src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/sf-live-slp.png"
              alt
            />
          </div>

          <!-- 回到首页 -->
          <div class="scroll-left-home" v-if="!isScreen" @click="jumpHome('./homeIndex')">
            <img src="../../assets/img/gohome.png" alt />
          </div>
          <div class="scroll-left-home share" v-if="!isScreenShow" @click="openShareModel">分享</div>

          <!-- 功能模块 -->
          <div class="live-model-bom">
            <!-- 2021-11-16 分享调整位置 gxx -->

            <!-- end gxx -->
            <div @click="giveLike" class="like"></div>

            <div class="chat-join open" v-for="(item, index) in joinUser" :key="index">
              <img :src="item.avatar" alt />
              <span>{{ item.nick_name }} 加入了你的直播间</span>
            </div>

            <div :class="isScreen ? 'chat-room-hhh' : 'chat-room'">
              <div v-for="(item, index) in messageList" :key="index">
                <div class="chat-item" v-if="item.isTip">
                  <span>{{ item.content }}</span>
                </div>
                <div class="chat-item" v-else>
                  <img :src="basicUrl + 'lt_zhubo.png'" alt v-if="item.isAnchor" />
                  <img :src="basicUrl + 'lt_guanliyuan.png'" v-else-if="item.is_manager" alt />
                  <img :src="basicUrl + 'lt_fensi.png'" v-else-if="item.isFans" alt />
                  <img :src="basicUrl + 'lt_youke.png'" v-else alt />
                  <span
                    class="user-name"
                    :class="
                      item.isAnchor
                        ? 'perpo'
                        : item.isFans
                        ? 'yellow'
                        : item.isAnchor || item.is_manager
                        ? 'purple'
                        : 'blue'
                    "
                  >{{ item.uid }} {{ item.nick_name }}</span>
                  <span>{{ item.content }}</span>
                </div>
              </div>
            </div>

            <!-- 正在讲解的商品   start -->
            <div
              v-if="explainCommodities.goods_id"
              class="live-explain-good"
              @click.stop="goShopDetail(explainCommodities)"
              :class="{ key: explainCommodities.goods_id }"
            >
              <img :src="explainCommodities.goods_image" class="explain-good-img" />
              <div>
                <div class="explain-mark">
                  <div class="mark-dot"></div>
                  <div>正在讲解</div>
                </div>
                <div
                  class="explain-good-name"
                >{{ explainCommodities.goods_name || explainCommodities.name }}</div>
                <div
                  class="explain-good-price"
                  v-if="explainCommodities.activity_status == 1"
                >￥{{ explainCommodities.activity_price }}</div>
                <div class="explain-good-price" v-else>
                  {{
                  explainCommodities.goods_price || explainCommodities.price
                  }}
                </div>
              </div>
            </div>

            <!-- 正在讲解的商品end -->
            <div class="live-input">
              <div class="live-input-flex">
                <div class="good-num" @click="showAllGood" v-if="goodsLists.length > 0">
                  <span>{{ goodsLists.length }}</span>
                </div>
                <div
                  class="input-tip"
                  :class="goodsLists.length > 0 ? 'key' : ''"
                  v-if="
                    liveInfo.info.not_speak == 1 ||
                    liveInfo.user.mute_status == 0
                  "
                >
                  {{
                  liveInfo.info.not_speak == 1
                  ? "全体禁言"
                  : liveInfo.user.mute_status == 0
                  ? "您已被禁言"
                  : ""
                  }}
                </div>
                <form class="search-block" v-else action="javascript:void 0">
                  <input
                    @keyup.13="tapToSearch"
                    @blur="scrollReset()"
                    v-model="messageInput"
                    placeholder="说点什么……"
                    type="text"
                    :class="goodsLists.length > 0 ? 'key' : ''"
                  />
                </form>
              </div>

              <div class="live-button">
                <img @click="isBottomPopup = true" :src="basicUrl + 'icongengduo.png'" alt />
                <!-- 点赞 -->
                <div class="dianzan-model">
                  <div class="dianzan-num" v-if="liveInfo.info.like_num > 0">
                    {{
                    liveInfo.info.like_num > 10000
                    ? liveInfo.info.like_num / 10000 + "万"
                    : liveInfo.info.like_num
                    }}
                  </div>
                  <img @click="startTimer" :src="basicUrl + 'iconguanzhu.png'" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item></van-swipe-item>
    </van-swipe>

    <!-- 异常退出弹框 -->
    <div class="follow_pop tac" v-if="isErrorPop">
      <div>
        <div class="follow_pop_title">直播异常</div>
        <div class="follow_pop_desc">是否继续等待?</div>
      </div>
      <div class="pop_btn_wrap">
        <div @click="logout" data-name="logout">退出直播</div>
        <div class="red" @click="isErrorPop = false">继续等待</div>
      </div>
    </div>

    <van-popup v-model="isInvitation" overlay class="invitation" position="bottom">
      <div class="invitation_title">
        <div>{{ isInvited ? "已" : "" }}邀请排行榜</div>
        <img class="close_invita" @click="isInvitation = false" :src="imgPath + 'live_guanbi.png'" />
      </div>
      <div class="invitation_scroll" @scroll="scrollEvent">
        <div
          v-for="(item, index) in isInvited ? invitaMyList : invitaList"
          class="flex_b invita_item"
          :key="index"
        >
          <div class="flex">
            <div :class="index < 3 ? 'invita_num' + (index + 1) : 'invita_num'">{{ index + 1 }}</div>
            <div class="invita_header" :class="{ key: item.is_online == 1 }">
              <img :src="item.avatar" />
            </div>
            <div class="invita_name">{{ item.nick_name }}</div>
          </div>
          <div class="invita_man">已邀请{{ item.num }}人</div>
        </div>
        <div v-if="(isInvited ? invitaMyList : invitaList).length == 0" class="no_invita_item">暂无数据</div>
      </div>
      <div class="flex_b invita_bom">
        <div class="flex">
          <div class="invita_num">{{ invitaInfo.rank_num }}</div>
          <img class="invita_header" :src="invitaInfo.avatar" alt />
          <div>
            <div class="flex invita_my_main">
              <div class="invita_my_name">{{ invitaInfo.nick_name }}</div>
              <div class="invita_my_man" @click="viewInvitaMy">已邀请{{ invitaInfo.share_user_num }}人</div>
              <img :src="imgPath + 'live_jinru.png'" class="icon_right" />
            </div>
            <div
              class="invita_diff"
              v-if="invitaInfo.rank_num != 1"
            >距离上一名还差{{ invitaInfo.diff_num }}人</div>
          </div>
        </div>
        <div class="invita_share" @click="openShareModel">分享</div>
      </div>
    </van-popup>

    <!-- 商品部分 -->
    <van-popup
      v-model="showGoodPop"
      :overlay="!(isScreenShow && isScreen)"
      :position="isScreenShow && isScreen ? 'left' : 'bottom'"
      :class="{ 'shop-popup': isScreenShow && isScreen }"
      :style="{ height: isScreenShow && isScreen ? '100vh' : '18.54rem' }"
    >
      <div class="shop-main-zzc" v-if="isScreenShow && isScreen" @click="showGoodPop = false"></div>
      <div class="shop-main" :class="{ 'shop-rotate': isScreenShow && isScreen }">
        <div class="shop-title">
          全部商品
          <span>{{ goodsLists.length }}</span>
        </div>
        <div class="shop-list">
          <div
            class="shop-item"
            v-for="(item, i) in goodsLists"
            @click.stop="goShopDetail(item)"
            :key="i"
          >
            <div class="shop-url">
              <img :src="item.goods_image" alt />
              <span
                class="quota"
                v-if="item.activity_status && item.buy_limit > 0"
              >每人限购{{ item.buy_limit }}</span>
              <span class="img-mark">{{ item.gkey }}</span>
            </div>
            <div class="shop-main">
              <div class="shop-name">{{ item.name }}</div>
              <div>
                <div
                  class="shop-stock"
                  v-for="(items, indexs) in item.tag_text"
                  :key="indexs"
                >{{ items }}</div>
              </div>
              <div class="shop-bay">
                <div v-if="item.activity_status">
                  <div class="goodsprice">￥{{ item.activity_price }}</div>
                  <div class="gray">市场价：{{ item.price }}</div>
                </div>
                <div v-else class="goodsprice">{{ item.price }}</div>
                <div class="right-btns">
                  <div class="item-explained" @click.stop="explanation(item)">
                    {{
                    item.goods_id == explainCommodities.goods_id
                    ? "正在讲解"
                    : "求讲解"
                    }}
                  </div>
                  <div class="item-buybtn" @click.stop="buyFg(item)">购买</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import http from './http'
import Vue from 'vue'
import { QNRTPlayer } from 'qn-rtplayer-web'
import { Dialog, Popup, Swipe, SwipeItem, Loading, Toast } from 'vant'
Vue.use(Swipe).use(SwipeItem).use(Popup).use(Loading)
import lottie from 'lottie-web'
import TIM from 'tim-js-sdk'

import 'xgplayer'
import Player from 'xgplayer-hls'

Vue.prototype.TIM = TIM
let MESSAGE_RECEIVED = ''
let LIVE_LOG = ''

export default {
  name: 'live-qdd-model',
  props: {
    loginUser: {
      default: () => {
        return {
          union_id: null,
          nick_name: '默认用户',
          uid: null,
          avatar:
            'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJoicIqXrbTSXeOfjbYicWpC9ibYlrCGSicb0buu2mVx7M4uquatcP58bwRwgu8yovesu8AYJU2eqs7Cg/132',
          app_key: null,
          live_id: null,
          user_id: null,
          open_id: null,
          wechat_app_id: null,
        }
      },
      type: Object,
    },
  },
  data() {
    return {
      token: null,
      basicUrl:
        'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/live_img/',
      messageList: [],
      userInfo: {}, // 用户详情
      liveInfo: {
        // 直播信息
        info: {},
        live_user: {},
        user: {},
      },
      playerName: ['播放器一', '播放器二', '播放器三'],
      currentPlayer: 0, // 0 七牛 1 西瓜 3 阿里
      messageInput: '', // 输入框
      tim: null,
      isFans: false, // 是否是粉丝
      isBottomPopup: false, // 是否开启底部弹窗 （关注 or 举报）
      // like1: false, // 点赞
      likenum: 0, // 点赞数量
      joinUser: [], // 加入动画
      isShowInit: true, // 初始   化
      isLiveLoading: true, // 视频加载中
      isPageLoading: false, // 直播加载中
      isScreen: false, // 横竖屏切换
      isScreenShow: false, // 是否时竖屏
      likePostion: {
        // 红心的位置
        x: 0,
        y: 0,
      },
      timer: null,
      isErrorPop: false, // 异常报错
      // 商品
      isClickGoods: false,
      goodsLists: [],
      showGoodPop: false,
      explainCommodities: {}, // 正在讲解的商品
      rightButton: [],
      p: [],
      isPlaying: true,
      timerlive: null, // 离开倒计时
      isInvitation: false, // 排行榜
      rankTimer: null,
      invitaList: [], //排行榜列表
      invitaMyList: [], // 个人的邀请列表
      invitaPage: 1,
      invitaFew: [], // 旁行榜前三名
      invitaInfo: {}, // 查看个人信息
      isInvited: false,
      realNumber: 0,
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight,
    }
  },
  mounted() {
    for (let i in this.loginUser) {
      this[i] = this.loginUser[i]
    }
    console.log(localStorage.getItem('playerType') == true, '000')
    if (localStorage.getItem('playerType')) {
      this.currentPlayer = localStorage.getItem('playerType')
    } else {
      localStorage.setItem('playerType', '0')
    }

    this.init()
  },
  activated() {
    this.isBottomPopup = false
  },
  methods: {
    scrollReset() {
      //兼容苹果手机键盘输入后不回缩
      window.scroll(0, 0) //让页面归位
    },
    // 切换播放器
    checkPlayer(val) {
      let _this = this
      let cur = localStorage.getItem('playerType')

      switch (cur) {
        case '0':
          _this.player.release()
          break
        case '1':
          _this.player.destroy()
          break
        default:
          _this.player.off('ready', _this.handleReady)

          _this.player.dispose()
      }
      localStorage.setItem('playerType', val)
      location.reload()
    },
    // 打开查看
    async openWatchFg() {
      this.getShareLiveRankFg()
      // 个人
      let res = await this.http('ClientLive.getLiveMemberShareData', {
        live_id: this.live_id,
        scenes_id: this.liveInfo.info.scenes_id,
      })
      if (res.status == 200) {
        this.isInvitation = true
        this.isInvited = false
        this.invitaInfo = res.content
      }
    },
    // 特邀排行榜
    async getShareLiveRankFg() {
      let _this = this
      let res = await this.http('ClientLive.getShareLiveRankList', {
        live_id: this.live_id,
        scenes_id: this.liveInfo.info.scenes_id,
        page: 1,
        limit: 10,
      })
      if (res.status == 200) {
        this.invitaList = res.content.list
        this.invitaFew = res.content.list.slice(0, 3)
      }
    },

    // 个人的邀请人列表
    async memberShareLive() {
      let res = await this.http('ClientLive.getMemberShareLiveUserList', {
        live_id: this.live_id,
        scenes_id: this.liveInfo.info.scenes_id,
        page: this.invitaPage,
        limit: 10,
      })
      if (res.status == 200) {
        this.invitaMyList =
          this.invitaPage == 1
            ? res.content.list
            : [...this.invitaMyList, ...res.content.list]
      }
    },

    // 打开查看已邀请的列表
    viewInvitaMy() {
      this.invitaPage = 1
      this.isInvited = true
      this.memberShareLive()
    },

    getShareHeartFg() {
      // 记录真实心跳
      this.http('ClientLive.addHeart', {
        live_id: this.live_id,
        scenes_id: this.liveInfo.info.scenes_id,
      }).then((res) => {
        if (res.status == 200) {
          _this.realNumber = res.content.user_num
        }
      })
    },
    // // 频繁调取直播人数
    // getGroupOnlineMember() {
    //   let promise = this.tim.getGroupOnlineMemberCount(this.userInfo.group_id)
    //   let _this = this
    //   promise
    //     .then(function (imResponse) {
    //       if (imResponse.data.memberCount > 0) {
    //         _this.realNumber = imResponse.data.memberCount
    //         setTimeout(() => {
    //           _this.getGroupOnlineMember()
    //         }, 5000)
    //       }
    //     })
    //     .catch(function (imError) {
    //       console.warn('getGroupOnlineMemberCount error:', imError) // 获取直播群在线人数失败的相关信息
    //     })
    // },

    openShareModel() {
      this.$emit('shareFg')
    },
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight ==
          e.srcElement.scrollHeight &&
        this.invitaMyList.length % 10 == 0
      ) {
        this.invitaPage++
        this.memberShareLive()
        console.log('嘿嘿我在底部触发了')
      }
    },
    jumpHome(url) {
      this.$router.replace({ path: url })
    },
    async init() {
      await this.login()
      await this.getliveFg()
    },

    // 横屏时 横竖屏切换
    changeScreenFg(status) {
      let _this = this

      if (status) {
        console.log(this.player)
        console.log(this.isScreenShow, this.isScreen)
        if (this.isScreenShow && this.isScreen) {
          this.player.exitCssFullscreen()
        }
      }
      this.isScreen = !this.isScreen
    },

    // 登陆
    async login() {
      let { content, status, msg } = await http('Xcx.User.login', {
        live_id: this.live_id,
        open_id: this.open_id,
        union_id: this.union_id,
        nick_name: this.nick_name,
        avatar: this.avatar,
        wechat_app_id: this.wechat_app_id,
        app_key: this.app_key,
        uid: this.user_id,
      })
      if (status == 200) {
        this.userInfo = content.info
        this.token = content.info.token
      }
    },
    // 获取直播信息
    async getliveFg(index) {
      let _this = this
      let res = await http(
        'Xcx.Live.getInfo',
        {
          live_id: this.live_id,
          app_key: this.app_key,
        },
        this.token
      )
      // 加载
      this.isPageLoading = true
      if (res.status != 200) {
        return
      }
      if (res.content.advert && res.content.advert.length) {
        this.rightButton = res.content.advert.splice(0, 2)
      }
      this.isScreenShow = res.content.info.screen == 0 ? true : false
      this.liveInfo = res.content
      if (this.liveInfo.user.black_status == 0) {
        Toast('您已被主播踢出房间，即将退出')
        setTimeout(() => {
          this.$emit('liveModel', {
            type: 'error',
          })
        }, 1500)
        return
      }

      if (this.messageList.length == 0) {
        this.messageList = [
          {
            content: res.content.info.chat_notice,
            isTip: true,
          },
        ]
      }
      // 直播状态 0未开始 1进行中 2已结束 3 非正常结束
      if (res.content.info.status == 3) {
        this.errorPopFg()
      }
      //  && !this.isScreenShow
      if (res.content.info.status == 1) {
        if (this.rankTimer) {
          clearInterval(this.rankTimer)
        }
        this.getShareHeartFg()
        this.rankTimer = setInterval(() => {
          this.getShareHeartFg()
        }, 5000)
      }
      if (res.content.info.status != 2) {
        if (index == 1) {
          console.log(this.liveInfo.info.pull_hls_url, '00')
          this.player.start(this.liveInfo.info.pull_hls_url)
          return
        }
        if (index == 2) {
          //阿里播放  防止直播流延迟
          console.log('000')
          this.player.loadByUrl(this.liveInfo.info.pull_hls_url)
          this.player.on('ready', _this.handleReady)
          return
        }
        this.openLive()
        this.IMInit()
        this.getGoodsLists()
        this.getScenesIdUpCount()
      }
      if (sessionStorage.getItem('isAddLiveBehavior')) {
        sessionStorage.removeItem('isAddLiveBehavior')
        this.addLiveBehaviorFg()
      }
    },
    // 记录分享关系

    async addLiveBehaviorFg() {
      await this.http('ClientLive.addLiveBehavior', {
        live_id: this.live_id,
        scenes_id: this.liveInfo.info.scenes_id,
        share_sign_no: localStorage.getItem('shareId'),
        // type:2 // 预告进去  不传默认1
      })
    },

    // 直播异常
    errorPopFg() {
      let _this = this
      if (this.isScreenShow && this.isScreen) {
        this.isErrorPop = true
      } else {
        Dialog.confirm({
          title: '直播异常',
          message: '是否继续等待',
          cancelButtonText: '继续等待',
          confirmButtonText: '退出直播',
        })
          .then((res) => {
            // on confirm
            _this.$emit('liveModel', {
              type: 'error',
            })
          })
          .catch(() => {
            console.log(222)
          })
      }
    },

    // 打开直播
    async openLive() {
      this.currentPlayer == 0
        ? this.openQNRTPlayer()
        : this.currentPlayer == 1
        ? this.openXiGuaPlayer()
        : this.openALIPlayer()

      this.isPlaying = false
    },
    async openQNRTPlayer() {
      this.player = await new QNRTPlayer()
      await this.player.init({
        className: 'container',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        volumn: 0.5,
        controls: false,
        playsinline: true,
      })
    },
    openXiGuaPlayer() {
      this.player = new Player(
        {
          id: 'container',
          url: this.liveInfo.info.pull_hls_url,
          isLive: true,
          width: '100%',
          height: '100%',
          fitVideoSize: 'fixWidth',
          volume: 1,
          hasStart: true,
          autoplay: true,
          fluid: true,
          cssFullscreen: true,
          ignores: [
            'time',
            'definition',
            'error',
            'fullscreen',
            'i18n',
            'loading',
            'mobile',
            'pc',
            'play',
            'poster',
            'progress',
            'replay',
            'volume',
          ],
          'x5-video-player-fullscreen': false,
          playsinline: true,
        },
        function (player) {
          player.play()
        }
      )
      let _this = this

      _this.player.on('exitCssFullscreen', function () {
        //事件名称可以在上述查询
        _this.openXiGuaPlayer()
        // _this.player.start(_this.liveInfo.info.pull_hls_url)
      })

      this.player.once('complete', () => {
        try {
          this.player.play() // 尝试再次执行播放
          setTimeout(() => {
            // 500毫秒收检测
            if (!this.player.hasStart && this.player.currentTime === 0) {
              // hasStart返回false，并且播放时间还是0，那么就可以认为自动播放失效了
              _this.isShowInit = false
            }
          }, 800)
        } catch (e) {
          console.log(e)
        }
      })
    },
    openALIPlayer() {
      let _this = this
      if (this.player) {
        this.player.dispose()
      }
      this.player = new Aliplayer(
        {
          id: 'container',
          autoplay: false,
          source: this.liveInfo.info.pull_hls_url,
          isLive: true,
          width: '100%', //容器的大小
          height: '100%',
          x5_type: 'h5',
          playsinline: true,
          useH5Prism: true,
          autoPlayDelay: 3,
          preload: true,
          skinLayout: [
            {
              name: 'controlBar',
              align: 'blabs',
              x: 0,
              y: 0,
              children: [],
            },
          ],
          hlsFrameChasing: true,
        },
        function (player) {
          console.log('The player is created')
        }
      )

      this.player.on('autoplay', function (data) {
        if (data.paramData) {
          //可以自动播放
          _this.isShowInit = false
          _this.isLiveLoading = false
        } //不可以自动播放
        else {
          _this.isShowInit = true
        }
      })
    },
    handleReady(e) {
      let _this = this
      _this.player.play()
    },
    // 开始播放
    openLiveFg() {
      let _this = this
      let index = this.currentPlayer

      //西瓜
      if (index == '1') {
        this.getliveFg(1)
        this.player.start(this.liveInfo.info.pull_hls_url)
      }
      //阿里
      if (index == '2') {
        this.getliveFg(2)
      }
      // 七牛
      if (index == '0') {
        this.player.play(
          this.liveInfo.info.pull_hls_url,
          document.getElementById('container')
        )
        this.player.init()
      }

      if (!this.player && !this.liveInfo.info.scenes_id) {
        _this.$emit('liveModel', {
          type: 'error',
        })
        return
      }

      this.isShowInit = false
      this.isLiveLoading = false
    },

    isVideo(key = 0) {
      let _this = this
      if (
        _this.player.hasVideo() &&
        !_this.player.isPlaying() &&
        _this.isPlaying
      ) {
        if (key >= 3) {
          _this.isLiveLoading = true
          _this.isShowInit = true
          _this.player.release()
          _this.player.off('log', LIVE_LOG)
        } else {
          setTimeout(() => {
            _this.isVideo(key + 1)
          }, 1000)
        }
      } else {
        _this.player.unmuteAudio()
      }
    },

    // 打开Im
    async IMInit() {
      let _this = this
      let options = {
        SDKAppID: 1400406682, // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
      }
      // 创建IM
      this.tim = this.TIM.create(options)
      // 登陆IM
      let promise = this.tim.login({
        userID: this.userInfo.uuid,
        userSig: this.userInfo.usersig,
      })

      promise
        .then((imResponse) => {
          console.log(imResponse.data) // 登录成功
          if (imResponse.data.repeatLogin === true) {
            // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
            let promise = this.tim.logout(true)
            promise
              .then(function (imResponse) {
                this.IMInit()
                console.log(imResponse.data) // 登出成功
              })
              .catch(function (imError) {
                console.warn('logout error:', imError)
              })
            return
          }
          //加入群聊
          _this.tim
            .joinGroup({
              groupID: _this.userInfo.group_id,
              applyMessage: '',
              type: 'TIM.TYPES.GRP_AVCHATROOM',
            })
            .then((res) => {
              let join = {
                content: '加入了直播间',
                content_type: 10003,
                nick_name: this.userInfo.nick_name,
                avatar: this.userInfo.avatar,
                user_id: this.userInfo.uuid,
              }
              this.joinUser = [...this.joinUser, join]
              _this.sendMessageFg(join)
              _this.animate('joinUser', 2000)
              console.log(res)
              // _this.getGroupOnlineMember() // 真实人数
            })

          MESSAGE_RECEIVED = function (event) {
            if (event.data.length == 0) {
              return
            }
            event.data.map((item) => {
              let message
              if (item && item.payload && item.payload.text) {
                message = JSON.parse(item.payload.text)
              }
              if (!message || !message.content_type) {
                return
              }
              console.log('------------')
              console.log(message.content_type)
              console.log(message)
              if (message.content_type == '10001') {
                message.isFans = message.isFans == 1
                _this.messageList = _this.messageList.slice(0, 100)
                _this.messageList = [message, ..._this.messageList]
              } else if (message.content_type == '10002') {
                message.isAnchor = true
                _this.messageList = _this.messageList.slice(0, 100)
                _this.messageList = [message, ..._this.messageList]
              } else if (message.content_type == '10003') {
                if (_this.joinUser.length == 0) {
                  _this.joinUser = [..._this.joinUser, message]
                  _this.animate('joinUser', 2000)
                }
              } else if (message.content_type == '10005') {
                _this.liveInfo.info.watch_num = message.audi_num
                  ? message.audi_num
                  : _this.liveInfo.info.watch_num
                _this.liveInfo.info.like_num =
                  _this.liveInfo.info.like_num == 0
                    ? message.like_num
                    : _this.liveInfo.info.like_num
              } else if (message.content_type == '10007') {
                if (_this.tim) {
                  _this.tim.logout()
                  _this.tim.off(_this.TIM.EVENT.SDK_READY, (res) => {
                    console.log('111')
                    console.log(res)
                  })
                  _this.tim.off(
                    _this.TIM.EVENT.MESSAGE_RECEIVED,
                    MESSAGE_RECEIVED
                  )
                }
                _this.getEndDetails()
                return
              } else if (message.content_type == '10008') {
                //主播离开直播间
                Toast('主播暂时离开，马上回来')
                _this.timerlive = setTimeout(() => {
                  _this.liveInfo.info.status = 4
                  _this.errorPopFg()
                }, 2000)
              } else if (message.content_type == '10009') {
                Toast('主播回来了！')
                // _this.openLiveFg()
                _this.liveInfo.info.status = 1
                _this.player.resume()
                if (_this.timerlive) {
                  clearTimeout(_this.timerlive)
                }
              } else if (message.content_type == '10010') {
                // _this.like1 = true
                _this.likenum += 1
                if (_this.likenum > 20) {
                  _this.likenum = 0
                }
                _this.liveInfo.info.like_num++
              } else if (message.content_type == '10011') {
                // 全体禁言
                Toast('主播已全体禁言')
                _this.liveInfo.info.not_speak = 1
              } else if (message.content_type == '10012') {
                // 禁言
                console.log(message.user_id, _this.user_id)
                if (message.user_id == _this.userInfo.uuid) {
                  Toast('主播已将您禁言')
                  _this.liveInfo.user.mute_status = 0
                }
              } else if (message.content_type == '10013') {
                if (message.user_id == _this.userInfo.uuid) {
                  Toast('主播已取消禁言')
                  _this.liveInfo.user.mute_status = 1
                }
              } else if (message.content_type == '10014') {
                // 拉黑
                if (message.user_id == _this.userInfo.uuid) {
                  _this.liveInfo.user.black_status = 0
                  _this.$emit('liveModel', {
                    type: 'back',
                  })
                  // setTimeout(() => {
                  //   _this.logout()
                  // }, 3000)
                }
              } else if (message.content_type == 10021) {
                // 取消全体禁言
                Toast('主播已取消全体禁言')
                _this.liveInfo.info.not_speak = 0
              } else if (message.content_type == 10022) {
                //主播异常结束
                _this.liveInfo.info.status = 3
                _this.errorPopFg()
                return
              } else if (message.content_type == 20001) {
                // _this.goodsLists = []
                _this.getGoodsLists()
              } else if (message.content_type == 10017) {
                // 正在讲解的商品列表
                _this.explainCommodities = message
              } else if (
                message.content_type == 10018 ||
                message.content_type == 10019
              ) {
                if (message.goods_id == _this.explainCommodities.goods_id) {
                  _this.explainCommodities = message
                }
                _this.getGoodsLists()
                //上下架商品
                _this.getScenesIdUpCount()
                return
              } else if (message.content_type == 10025) {
                // 广告位发生改变
                _this.rightButton = message.list
              } else if (message.content_type == 10027) {
                console.log(message.goods_id, _this.explainCommodities.id)
                console.log(message.goods_id == _this.explainCommodities.id)
                console.log(message, _this.explainCommodities)
                if (
                  message.goods_id == _this.explainCommodities.id ||
                  message.goods_id == _this.explainCommodities.gid
                ) {
                  _this.explainCommodities = {
                    ..._this.explainCommodities,
                    ...message,
                  }
                }
              }
            })
          }

          _this.tim.on(_this.TIM.EVENT.SDK_READY, function (event) {
            console.log(event)
          })

          // 聊天记录
          _this.tim.on(_this.TIM.EVENT.MESSAGE_RECEIVED, MESSAGE_RECEIVED)
        })
        .catch(function (imError) {
          console.info('login error:', imError) // 登录失败的相关信息
        })
    },
    // 进入举报页面
    goReportsFg() {
      this.$emit('liveModel', {
        type: 'report',
      })
    },
    // 进入动画
    animate(list, time) {
      setTimeout(() => {
        if (this[list].length > 0) {
          this.joinUser.shift()
          this.animate(list, time)
        }
      }, time)
    },

    async showAllGood() {
      if (this.isClickGoods) return
      this.goodsLists = []
      this.showGoodPop = true
      this.isClickGoods = true
      await this.getGoodsLists()
      setTimeout(() => {
        this.isClickGoods = false
      }, 1000)
    },

    // 获取商品列表
    async getGoodsLists() {
      let _this = this
      let res = await http(
        'Xcx.LiveGoods.getScenesIdUpList',
        {
          live_id: this.live_id,
          app_key: this.app_key,
          scenes_id: this.liveInfo.info.scenes_id || '',
          limit: 100,
          page: 1,
        },
        this.token
      )
      if (res.status == 200) {
        if (res.content.list.length) {
          res.content.list.forEach((x) => {
            x.activity_status = parseInt(x.activity_status)
          })
        }
        _this.goodsLists = res.content.list || []
        if (
          res.content.list.filter((item) => {
            return _this.explainCommodities.goods_id == item.goods_id
          }).length == 0
        ) {
          _this.explainCommodities = {}
        }
      }
    },

    // 取直播间商品数量与在讲解信息
    async getScenesIdUpCount() {
      let { content, status } = await http(
        'Xcx.LiveGoods.getScenesIdUpCount',
        {
          live_id: this.live_id,
          app_key: this.app_key,
          scenes_id: this.liveInfo.info.scenes_id || '',
        },
        this.token
      )
      if (status == 200) {
        this.goodsNum = content.goods_num
        this.explainCommodities = content.explain
      }
    },

    // 退出
    logout(isTm) {
      let _this = this
      this.rankTimer ? clearInterval(this.rankTimer) : ''
      let params = {
        content: '退出',
        content_type: 10004,
      }
      // 退出直播间
      this.sendMessageFg(params)
      if (!isTm) {
        _this.$emit('liveModel', {
          type: 'error',
        })
      }
      console.log('99999999999999999999')
      _this.player.off('log', LIVE_LOG)
      if (this.currentPlayer == 0) {
        _this.player.release()
      }

      _this.isShowInit = false // 初始化
      _this.isLiveLoading = true // 视频加载中
      _this.isPageLoading = false // 直播加载中
      // _this.player = null
      _this.tim.off(_this.TIM.EVENT.SDK_READY, (res) => {
        console.log('111')
        console.log(res)
      })
      console.log('...................................')
      _this.tim.off(_this.TIM.EVENT.MESSAGE_RECEIVED, MESSAGE_RECEIVED)
      _this.tim.logout()
      // this.tim.off(TIM.EVENT.SDK_READY)
      // this.tim.off(TIM.EVENT.MESSAGE_RECEIVED)
    },

    // 获取直播结束详情
    async getEndDetails() {
      let _this = this
      _this.liveInfo.info.status = 2
      let { content, status } = await http(
        'Xcx.Live.getEndCount',
        {
          live_id: this.live_id,
          app_key: this.app_key,
        },
        this.token
      )
      if (status == 200) {
        _this.liveInfo.info.like_num = content.info.like_num
        _this.liveInfo.info.watch_num = content.info.watch_num
        _this.liveInfo.info.length_time = content.info.length_time
      }
    },

    // 点赞
    giveLike(e) {
      var e = event || window.event
      const icon = document.querySelector('.give-like-icon')
      if (this.isGiveLike) {
        this.timer ? clearInterval(this.timer) : null
        this.timer = setTimeout(() => {
          lottie.destroy()
          this.isGiveLike = false
        }, 1000)
        this.timer
      }
      this.isGiveLike = true
      this.likePostion.x = e.pageX - icon.offsetWidth / 2
      this.likePostion.y = e.pageY - icon.offsetWidth / 2
      lottie.loadAnimation({
        container: icon, // 包含动画的dom元素
        renderer: 'svg', //渲染出来的是什么格式
        loop: false, //循环播放
        autoplay: true, //自动播放
        path: 'https://qdd-live-public-service.7dingdong.com/gift/dian_xin.json',
      })
      this.startTimer()
    },

    // 退出
    triggerMethod() {
      this.$emit('liveModel', {
        type: 'back',
      })
      this.rankTimer ? clearInterval(this.rankTimer) : ''
    },

    // 点赞
    startTimer: function () {
      this.likenum += 1
      let text = {
        content: '点赞',
        content_type: '10010',
      }
      if (this.likenum > 20) {
        this.likenum = 0
      }
      this.liveInfo.info.like_num++
      this.sendMessageFg(text)
    },

    //  求讲解
    explanation: function (item) {
      // 求讲解
      let params = {
        goods_id: item.goods_id,
        goods_image: item.goods_image,
        goods_number: item.gkey,
        content_type: '10016',
        content: '求讲解',
      }
      console.log(item)
      Toast('已通知主播')
      this.sendMessageFg(params)
    },

    // 关注
    async focusFg() {
      let is_follow = this.liveInfo.user.follow_status
      let text = {
        content: is_follow == 0 ? '点了关注' : '取消了关注',
        content_type: is_follow == 0 ? 10006 : 20002,
        scenes_id: this.liveInfo.info.scenes_id || '',
      }
      console.log(this.liveInfo.info.scenes_id)
      let { status } = await http(
        'Xcx.LiveUser.addLiveUserBindUid',
        {
          live_id: this.live_id,
          app_key: this.app_key,
          scenes_id: this.liveInfo.info.scenes_id || '',
          type: 'follow',
        },
        this.token
      )
      if (status == 100) {
        this.init()
        return
      }
      this.liveInfo.user.follow_status = is_follow == 0 ? 1 : 0
      this.isBottomPopup = false
      Toast(is_follow == 0 ? '关注成功' : '已取消关注')
      this.sendMessageFg(text)
    },

    // 发送消息
    tapToSearch() {
      if (this.messageInput == '') return
      let _this = this
      let text = {
        content: this.messageInput,
        content_type: 10001,
        isFans: this.liveInfo.user.follow_status,
        nick_name: this.userInfo.nick_name,
        avatar: this.userInfo.avatar,
        user_id: this.userInfo.uuid,
        uid: localStorage.getItem('member_id'),
      }
      console.log(text)
      _this.messageList = _this.messageList.slice(0, 100)
      _this.messageList = [text, ..._this.messageList]
      _this.messageInput = ''
      _this.sendMessageFg(text)
    },

    // 创建消息主体
    sendMessageFg(text) {
      text = {
        ...text,
        nick_name: this.userInfo.nick_name,
        avatar: this.userInfo.avatar,
        user_id: this.userInfo.uuid,
      }
      console.log(text)
      let _this = this
      let message = _this.tim.createTextMessage({
        to: _this.userInfo.group_id,
        conversationType: this.TIM.TYPES.CONV_GROUP,
        payload: { text: JSON.stringify(text) },
      })
      let promise = this.tim.sendMessage(message)
      promise
        .then(function (imResponse) {
          // 发送成功
          console.log(imResponse)
        })
        .catch(function (imError) {
          // 发送失败
          console.warn('sendMessage error:', imError)
        })
    },
    // 购买
    buyFg(item) {
      let params = {
        content: '去购买',
        content_type: 10020,
      }
      this.sendMessageFg(params)
      this.$emit('liveModel', {
        type: 'buy',
        data: {
          ...item,
          scenes_id: this.liveInfo.info.scenes_id,
        },
      })
    },
    // 进入商品详情
    goShopDetail(item) {
      this.$emit('liveModel', {
        type: 'goShop',
        data: {
          ...item,
          scenes_id: this.liveInfo.info.scenes_id,
        },
      })
    },

    // 抛出广告位
    advertFg(item) {
      this.$emit('liveModel', {
        type: 'advert',
        data: item,
      })
    },
  },
}
</script>

<style>
.alyPlayeVideo video {
  position: fixed !important;
  width: 102vw !important;
  height: 12.5rem !important;
  top: 4.5625rem !important;
}
.alyPlayeVideoHeng video {
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
}
.operators {
  display: none;
}
.xgplayer-skin-default .xgplayer-start,
.xgplayer-skin-default .xgplayer-controls {
  display: none !important;
}
.xgplayer-start,
.xgplayer-tips {
  display: none !important;
}
.container.container-vertical.xgplayer-playing video {
  width: 100%;
  height: 100%;
}
.share_x {
  width: 20%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 28px;
  color: #fff;
  background: linear-gradient(221deg, #ff7271 0%, #fc3e3d 100%);
}
.column_x {
  color: #fff;
  font-size: 30px;
  height: 60px;
  z-index: 3;
  width: 100%;
  position: absolute;
  right: 0;
  top: 16.4rem;
}
.column_x p {
  width: 74%;
  padding-left: 24px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.give-like-icon svg {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
}
.zs {
  position: fixed;
  z-index: 9999;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 30vh;
  overflow-y: scroll;
  background: #fff;
}
</style>
<style lang="scss" scoped>
@import './liveModek.scss';
</style>
